window.site = (window.site || {});

/**
 * Init Offers Galleries with Swiper
 * @class Site
 * @static
 */
site.OffersGalleries = (function OffersGalleries() {

  'use strict';

  var inited = false;

  /**
   * Convert existing gallery to Swiper structure and initialize
   */
  function initSwiper(container, options = {}) {
    if (!container) return null;

    const images = Array.from(container.querySelectorAll('img'));
    if (images.length === 0) return null;

    // Create Swiper structure
    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    images.forEach((img) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(img.cloneNode(true));
      wrapper.appendChild(slide);
    });

    // Clear container using DOM methods
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }

    container.classList.add('swiper');
    container.appendChild(wrapper);

    // Add navigation
    const prevBtn = document.createElement('div');
    prevBtn.className = 'swiper-button-prev';
    container.appendChild(prevBtn);

    const nextBtn = document.createElement('div');
    nextBtn.className = 'swiper-button-next';
    container.appendChild(nextBtn);

    // Initialize Swiper
    return new window.Swiper(container, {
      modules: [window.SwiperModules.Navigation],
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      ...options
    });
  }

  var init = function () {
    if (inited) return false;
    inited = true;

    const $offers = document.querySelectorAll('.offers.is-active .offer');
    const $studyAreas = document.querySelectorAll('.study-areas .study-area');
    const $spaces = document.querySelectorAll('.results-listing .result-item');

    $offers.forEach(($offer) => {
      const $slider = $offer.querySelector('.offer-gallery');
      initSwiper($slider);
    });

    $spaces.forEach(($space) => {
      const $slider = $space.querySelector('.result-item-gallery');
      initSwiper($slider);
    });

    $studyAreas.forEach(($area) => {
      const $slider = $area.querySelector('.study-area-gallery');
      initSwiper($slider);
    });

    return true;
  };

  return {
    init: init,
    initSwiper: initSwiper,
  };

}());
